import React from "react";
import {HOME, SIGN_IN} from "../../constants/routes";
import {Link} from "react-router-dom";
import {urlLogo} from "../../constants/asseturls";

/**
 * Version of the navbar that is displayed when there is no authenticated user.
 */
export const NavbarNonAuth = () => {
    return (
        <div className="container">
            <Link className="navbar-brand" to={HOME}><img className="logoStyle" src={urlLogo} alt="AutoI" /></Link>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item text-center" style={{marginRight: 5}}>
                        <Link className="btn btn-md btn-primary btn-block" to={SIGN_IN}>Sign In</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/navigationbar/NavbarNonAuth.jsx